module.exports = __webpack_public_path__ + "img/9788955472479.b676a2eb.jpg";